(function () {
  const BULK_PRICING_KEY = 'mtc_bulk_pricing';

  // Shared HTML-escape helper.
  // Defined here because mtc-card-badges.js is always
  // loaded before mtc-product-card.js, which consumes
  // the same window.Mtc.escHtml.
  window.Mtc = window.Mtc || {};

  window.Mtc.escHtml =
    window.Mtc.escHtml ||
    function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

  const escHtml = window.Mtc.escHtml;


  function getBulkPricing() {
    try {
      return JSON.parse(
        localStorage.getItem(BULK_PRICING_KEY) || '{}'
      );
    } catch (e) {
      return {};
    }
  }


  function buildBulkBadge(handle, variantAvailable) {

    const bulkData = getBulkPricing()[handle];
    const badge = window.mtcBulkBadge;

    if (!bulkData || !variantAvailable || !badge) {
      return '';
    }

    const badgePrice =
      `£${(bulkData.price / 100).toFixed(2)}`;

    const colorAttr = badge.color
      ? ` style="background:${escHtml(badge.color)}"`
      : '';

    return `
      <div class="bulk-rate-badge"${colorAttr}>

        <div class="bulk-rate-badge__quantity">

          <div class="bulk-rate-badge__number">
            ${escHtml(String(bulkData.qty))}
          </div>

          <img
            src="${escHtml(badge.imageUrl)}"
            alt=""
            class="bulk-rate-badge__img"
            width="20"
            height="20"
            loading="lazy"
          >

        </div>

        <div class="bulk-rate-badge__price">

          ${badgePrice}

          <span class="bulk-rate-badge__price—each">
            ${escHtml(badge.eachLabel)}
          </span>

        </div>

      </div>
    `;
  }


  function buildMetaBadge(label, cfg) {

    const entry = cfg.entries[label];

    if (!entry) {
      return '';
    }

    let badgeStyle = '';
    let badgeContent = '';


    if (entry.imageUrl) {

      badgeStyle = 'background:none;';

      badgeContent = `
        <img
          src="${escHtml(entry.imageUrl)}"
          alt=""
          loading="lazy"
        >
      `;

    } else {

      badgeStyle =
        `background-color:${escHtml(entry.color || '#000')};color:#fff;`;

      badgeContent =
        escHtml(entry.displayText || label);

    }


    return `
      <div
        class="product-badges__badge product-badges__badge--rectangle"
        style="${badgeStyle}"
      >
        ${badgeContent}
      </div>
    `;
  }


  function buildProductBadge(product) {

    const cfg = window.mtcBadges;

    if (!cfg) {
      return '';
    }


    /*
      SOLD OUT

      Preserve the existing behaviour:
      Sold Out takes priority over promotional badges.
    */

    if (!product.available) {

      return `
        <div
          class="product-badges product-badges--${escHtml(cfg.position)}"
          style="${escHtml(cfg.style)}"
        >

          <div
            class="
              product-badges__badge
              product-badges__badge--rectangle
              ${escHtml(cfg.soldOutClass)}
            "
          >
            ${escHtml(cfg.soldOutLabel)}
          </div>

        </div>
      `;
    }


    /*
      SALE

      Preserve the existing behaviour:
      Sale takes priority over promotional badges.
    */

    if (
      product.compare_at_price &&
      product.compare_at_price > product.price
    ) {

      return `
        <div
          class="product-badges product-badges--${escHtml(cfg.position)}"
          style="${escHtml(cfg.style)}"
        >

          <div
            class="
              product-badges__badge
              product-badges__badge--rectangle
              ${escHtml(cfg.saleClass)}
            "
          >
            ${escHtml(cfg.saleLabel)}
          </div>

        </div>
      `;
    }


    const tags =
      Array.isArray(product.tags)
        ? product.tags
        : [];


    /*
      PRIMARY PROMOTIONAL BADGE

      Priority:
      1. Pre Order
      2. Latest Deals
      3. Core Essentials
      4. Big Offers
      5. Clearance
      6. New in
    */

    let activeLabel = null;


    if (tags.includes('Pre Order')) {

      activeLabel = 'Pre Order';

    } else if (tags.includes('Latest Deals')) {

      activeLabel = 'Latest Deals';

    } else if (tags.includes('Core Essentials')) {

      activeLabel = 'Core Essentials';

    } else if (tags.includes('Big Offers')) {

      activeLabel = 'Big Offers';

    } else if (tags.includes('Clearance')) {

      activeLabel = 'Clearance';

    } else if (product.created_at) {

      const ageSeconds =
        (
          Date.now() -
          new Date(product.created_at).getTime()
        ) / 1000;

      if (ageSeconds < 2592000) {
        activeLabel = 'New in';
      }

    }


    let badgesHtml = '';


    /*
      Render the primary badge.
    */

    if (activeLabel) {

      badgesHtml += buildMetaBadge(
        activeLabel,
        cfg
      );

    }


    /*
      BIG OFFERS STACKING

      Big Offers can appear in addition to another primary
      promotional badge.

      For example:
      Core Essentials
      Big Offers

      If Big Offers is already activeLabel, do not add it twice.
    */

    if (
      tags.includes('Big Offers') &&
      activeLabel !== 'Big Offers'
    ) {

      badgesHtml += buildMetaBadge(
        'Big Offers',
        cfg
      );

    }


    if (!badgesHtml) {
      return '';
    }


    return `
      <div
        class="product-badges product-badges--${escHtml(cfg.position)}"
        style="${escHtml(cfg.style)}"
      >
        ${badgesHtml}
      </div>
    `;
  }


  window.MtcCardBadges = {
    buildBulkBadge,
    buildProductBadge
  };

})();